export default __webpack_public_path__ + "static/media/bg-about.9a182746.jpg";